import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AuthConstants } from 'app/services/authentication/auth-constants';

export enum contextType {
    ADF,
    Trident
}

export enum domains {
    ADF = 'https://docs.microsoft.com/azure/data-factory',
    Trident = 'https://go.microsoft.com/fwlink/?linkid=2230363'
}

type contextLinks = { [key in contextType]?: string };

// ----------------------------------------------------------------------------------
// Activity links
// ----------------------------------------------------------------------------------
export type activityType = 'approval' | 'azureDataExplorerCommand' | 'azureFunction' | 'azureHDInsight' | 'azureMLExecutePipeline' |
    'copy' | 'custom' | 'executeDataFlow' | 'dataFlowRefresh' | 'dbt' | 'delete' | 'executePipeline' | 'executeWranglingDataflow' | 'fabricWeb' | 'fail' | 'filter' | 'forEach' | 'getMetadata' |
    'hive' | 'ifCondition' | 'jar' | 'lookup' | 'mapReduce' | 'notebook' | 'pig' | 'python' | 'job' | 'scope' | 'script' | 'spark' | 'executeSSISPackage' |
    'storedProcedure' | 'streaming' | 'switch' | 'until' | 'uSql' | 'validation' | 'variables' | 'appendVariables' | 'wait' | 'web' | 'webHook' | 'lakehouseMaintenance' | 'refreshSqlEndpoint';

type ActivityLinkType = {
    [key in activityType]: contextLinks
};

interface ILinksMapType {
    [key: string]: contextLinks
}

export const activityLink: ActivityLinkType = {
    approval: {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2363504'
    },
    azureDataExplorerCommand: {
        [contextType.ADF]: `https://docs.microsoft.com/azure/data-explorer/data-factory-command-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230558'
    },
    azureFunction: {
        [contextType.ADF]: `${domains.ADF}/control-flow-azure-function-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2338824'
    },
    azureHDInsight: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-hadoop-hive`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230252'
    },
    azureMLExecutePipeline: {
        [contextType.ADF]: `${domains.ADF}/transform-data-machine-learning-service`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230632'
    },
    copy: {
        [contextType.ADF]: `${domains.ADF}/copy-activity-overview`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230606'
    },
    custom: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-dotnet-custom-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230559'
    },
    dbt: {
        [contextType.Trident]: ''
    },
    executeDataFlow: {
        [contextType.ADF]: `${domains.ADF}/control-flow-execute-data-flow-activity`
    },
    dataFlowRefresh: {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230560'
    },
    delete: {
        [contextType.ADF]: `${domains.ADF}/delete-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230633'
    },
    executePipeline: {
        [contextType.ADF]: `${domains.ADF}/control-flow-execute-pipeline-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230561'
    },
    executeWranglingDataflow: {
        [contextType.ADF]: `${domains.ADF}/control-flow-power-query-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230445'
    },
    fail: {
        [contextType.ADF]: `${domains.ADF}/control-flow-fail-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230356'
    },
    filter: {
        [contextType.ADF]: `${domains.ADF}/control-flow-filter-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230251'
    },
    forEach: {
        [contextType.ADF]: `${domains.ADF}/control-flow-for-each-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230634'
    },
    getMetadata: {
        [contextType.ADF]: `${domains.ADF}/control-flow-get-metadata-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230562'
    },
    hive: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-hadoop-hive`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230252'
    },
    ifCondition: {
        [contextType.ADF]: `${domains.ADF}/control-flow-if-condition-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230253'
    },
    jar: {
        [contextType.ADF]: `${domains.ADF}/transform-data-databricks-jar`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230254'
    },
    lookup: {
        [contextType.ADF]: `${domains.ADF}/control-flow-lookup-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230358'
    },
    mapReduce: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-hadoop-map-reduce`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230359'
    },
    notebook: {
        [contextType.ADF]: `${domains.ADF}/transform-data-databricks-notebook`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230563'
    },
    pig: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-hadoop-pig`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230635'
    },
    python: {
        [contextType.ADF]: `${domains.ADF}/transform-data-databricks-python`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230255'
    },
    scope: {
        [contextType.ADF]: 'https://msdata.visualstudio.com/Azure%20Data%20Factory/_wiki/wikis/Azure%20Data%20Factory.wiki/11121/Data-Lake-Scope-Activity',
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230256'
    },
    script: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-script`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230187'
    },
    spark: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-spark`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230360'
    },
    executeSSISPackage: {
        [contextType.ADF]: `${domains.ADF}/how-to-invoke-ssis-package-ssis-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230188'
    },
    storedProcedure: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-stored-procedure`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230189'
    },
    streaming: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-hadoop-streaming`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230257'
    },
    switch: {
        [contextType.ADF]: `${domains.ADF}/control-flow-switch-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230564'
    },
    until: {
        [contextType.ADF]: `${domains.ADF}/control-flow-until-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230446'
    },
    uSql: {
        [contextType.ADF]: `${domains.ADF}/transform-data-using-data-lake-analytics`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230636'
    },
    validation: {
        [contextType.ADF]: `${domains.ADF}/control-flow-validation-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230361'
    },
    variables: {
        [contextType.ADF]: `${domains.ADF}/control-flow-set-variable-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230190'
    },
    appendVariables: {
        [contextType.ADF]: `${domains.ADF}/control-flow-append-variable-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230191'
    },
    wait: {
        [contextType.ADF]: `${domains.ADF}/control-flow-wait-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230258'
    },
    web: {
        [contextType.ADF]: `${domains.ADF}/control-flow-web-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230192'
    },
    webHook: {
        [contextType.ADF]: `${domains.ADF}/control-flow-webhook-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230193'
    },
    job: {
        // TODO: waiting for valid link
        [contextType.ADF]: `${domains.ADF}/transform-data-databricks-job`,
        // TODO: waiting for valid link
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230255'
    },
    lakehouseMaintenance: {
        [contextType.ADF]: `${domains.ADF}/lakehouse-maintenance-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2358591'
    },
    refreshSqlEndpoint: {
        [contextType.ADF]: `${domains.ADF}/refresh-sql-endpoint-activity`,
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2358475'
    },
    fabricWeb: {
        [contextType.ADF]: '',
        [contextType.Trident]: ''
    }
};
// ----------------------------------------------------------------------------------

// ----------------------------------------------------------------------------------
// Connector links
// ----------------------------------------------------------------------------------
export type DocumentationSectionType = 'linked-service-properties' | 'dataset-properties' | 'copy-activity-properties'
    | 'lookup-activity-properties' | 'getmetadata-activity-properties' | 'delete-activity-properties';

export enum connectorType {
    dataStore,
    compute
}

type ConnectorDocLinkPrefixType = {
    [key in contextType]: string | { [key in connectorType]?: string }
};
export const connectorDocLinkPrefix: ConnectorDocLinkPrefixType = {
    [contextType.ADF]: {
        [connectorType.dataStore]: `${domains.ADF}/connector-`,
        [connectorType.compute]: `${domains.ADF}/compute-linked-services#`
    },
    [contextType.Trident]: `${domains.Trident}`
};

export const connectorDocLinkDictionary: ILinksMapType = {
    // data stores
    [adfModelTypeMap.amazonMWSMetadata.linkedServiceType]: {
        [contextType.ADF]: 'amazon-marketplace-web-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.amazonRedshift.linkedServiceType]: {
        [contextType.ADF]: 'amazon-redshift',
        [contextType.Trident]: 'https://aka.ms/AmazonRedshift'
    },
    [adfModelTypeMap.amazonS3.linkedServiceType]: {
        [contextType.ADF]: 'amazon-simple-storage-service',
        [contextType.Trident]: 'https://aka.ms/AmazonS3'
    },
    [adfModelTypeMap.amazonRdsForOracle.linkedServiceType]: {
        [contextType.ADF]: 'amazon-rds-for-oracle',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.amazonRdsSqlServer.linkedServiceType]: {
        [contextType.ADF]: 'amazon-rds-for-sql-server',
        [contextType.Trident]: 'https://aka.ms/AmazonRDSforSQLServer'
    },
    [adfModelTypeMap.amazonS3Compatible.linkedServiceType]: {
        [contextType.ADF]: 'amazon-s3-compatible-storage',
        [contextType.Trident]: 'https://aka.ms/AmazonS3Compatible'
    },
    [adfModelTypeMap.azureBlob.linkedServiceType]: {
        [contextType.ADF]: 'azure-blob-storage',
        [contextType.Trident]: 'https://aka.ms/AzureBlobStorageConnector'
    },
    [adfModelTypeMap.azureSearch.linkedServiceType]: {
        [contextType.ADF]: 'azure-search',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.cosmosSql.linkedServiceType]: {
        [contextType.ADF]: 'azure-cosmos-db',
        [contextType.Trident]: 'https://aka.ms/AzureCosmosDBforNoSQL'
    },
    [adfModelTypeMap.cosmosMongo.linkedServiceType]: {
        [contextType.ADF]: 'azure-cosmos-db-mongodb-api',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureDataExplorer.linkedServiceType]: {
        [contextType.ADF]: 'azure-data-explorer',
        [contextType.Trident]: 'https://aka.ms/AzureDataExplorerConnector'
    },
    [adfModelTypeMap.azureDataLakeStore.linkedServiceType]: {
        [contextType.ADF]: 'azure-data-lake-store',
        [contextType.Trident]: 'https://aka.ms/AzureDataLakeStorageGen1'
    },
    [adfModelTypeMap.azureBlobFS.linkedServiceType]: {
        [contextType.ADF]: 'azure-data-lake-storage',
        [contextType.Trident]: 'https://aka.ms/AzureDataLakeStorageGen2'
    },
    [adfModelTypeMap.azureMariaDB.linkedServiceType]: {
        [contextType.ADF]: 'azure-database-for-mariadb',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureMySql.linkedServiceType]: {
        [contextType.ADF]: 'azure-database-for-mysql',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azurePostgreSQL.linkedServiceType]: {
        [contextType.ADF]: 'azure-database-for-postgresql',
        [contextType.Trident]: 'https://aka.ms/AzureDatabaseforPostgreSQL'
    },
    [adfModelTypeMap.azureDatabricksDeltaLake.linkedServiceType]: {
        [contextType.ADF]: 'azure-databricks-delta-lake',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureFileStorage.linkedServiceType]: {
        [contextType.ADF]: 'azure-file-storage',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureSql.linkedServiceType]: {
        [contextType.ADF]: 'azure-sql-database',
        [contextType.Trident]: 'https://aka.ms/AzureSQLDatabase'
    },
    [adfModelTypeMap.azureSqlMI.linkedServiceType]: {
        [contextType.ADF]: 'azure-sql-managed-instance',
        [contextType.Trident]: 'https://aka.ms/AzureSQLDatabaseManagedInstance'
    },
    [adfModelTypeMap.azureSqlDW.linkedServiceType]: {
        [contextType.ADF]: 'azure-sql-data-warehouse',
        [contextType.Trident]: 'https://aka.ms/AzureSynapseAnalyticsConnector'
    },
    [adfModelTypeMap.azureTable.linkedServiceType]: {
        [contextType.ADF]: 'azure-table-storage',
        [contextType.Trident]: 'https://aka.ms/AzureTableStorage'
    },
    [adfModelTypeMap.cassandra.linkedServiceType]: {
        [contextType.ADF]: 'cassandra',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.dynamicsCRM.linkedServiceType]: {
        [contextType.ADF]: 'dynamics-crm-office-365',
        [contextType.Trident]: 'https://aka.ms/DynamicsCRMCopyConnector'
    },
    [adfModelTypeMap.commonDataService.linkedServiceType]: {
        [contextType.ADF]: 'dynamics-crm-office-365',
        [contextType.Trident]: 'https://aka.ms/DataverseCopyConnector'
    },
    [adfModelTypeMap.dynamics.linkedServiceType]: {
        [contextType.ADF]: 'dynamics-crm-office-365',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.concur.linkedServiceType]: {
        [contextType.ADF]: 'concur',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.couchbase.linkedServiceType]: {
        [contextType.ADF]: 'couchbase',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.db2.linkedServiceType]: {
        [contextType.ADF]: 'db2',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.drill.linkedServiceType]: {
        [contextType.ADF]: 'drill',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.dynamicsAX.linkedServiceType]: {
        [contextType.ADF]: 'dynamics-ax',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.fileServer.linkedServiceType]: {
        [contextType.ADF]: 'file-system',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.ftpServer.linkedServiceType]: {
        [contextType.ADF]: 'ftp',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.gitHub.linkedServiceType]: {
        [contextType.ADF]: 'github',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.googleAdWords.linkedServiceType]: {
        [contextType.ADF]: 'google-adwords',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.googleBigQuery.linkedServiceType]: {
        [contextType.ADF]: 'google-bigquery',
        [contextType.Trident]: 'https://aka.ms/GoogleBigQuery'
    },
    [adfModelTypeMap.googleBigQueryV2.linkedServiceType]: {
        [contextType.ADF]: 'google-bigquery',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.googleCloudStorage.linkedServiceType]: {
        [contextType.ADF]: 'google-cloud-storage',
        [contextType.Trident]: 'https://aka.ms/GoogleCloudStorage'
    },
    [adfModelTypeMap.greenplum.linkedServiceType]: {
        [contextType.ADF]: 'greenplum',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.hbase.linkedServiceType]: {
        [contextType.ADF]: 'hbase',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.hdfs.linkedServiceType]: {
        [contextType.ADF]: 'hdfs',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.hive.linkedServiceType]: {
        [contextType.ADF]: 'hive',
        [contextType.Trident]: 'https://aka.ms/HiveCopyConnector'
    },
    [adfModelTypeMap.httpServer.linkedServiceType]: {
        [contextType.ADF]: 'http',
        [contextType.Trident]: 'https://aka.ms/HTTPCopyConnector'
    },
    [adfModelTypeMap.hubspot.linkedServiceType]: {
        [contextType.ADF]: 'hubspot',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.impala.linkedServiceType]: {
        [contextType.ADF]: 'impala',
        [contextType.Trident]: 'https://aka.ms/ApacheImpala'
    },
    [adfModelTypeMap.informix.linkedServiceType]: {
        [contextType.ADF]: 'informix',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.jira.linkedServiceType]: {
        [contextType.ADF]: 'jira',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.mariaDB.linkedServiceType]: {
        [contextType.ADF]: 'mariadb',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.magento.linkedServiceType]: {
        [contextType.ADF]: 'magento',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.marketto.linkedServiceType]: {
        [contextType.ADF]: 'marketto',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.microsoftAccess.linkedServiceType]: {
        [contextType.ADF]: 'microsoft-access',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.mongoDb.linkedServiceType]: {
        [contextType.ADF]: 'mongodb',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.mongoDbAtlas.linkedServiceType]: {
        [contextType.ADF]: 'mongodb-atlas',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.mysql.linkedServiceType]: {
        [contextType.ADF]: 'mysql',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.netezza.linkedServiceType]: {
        [contextType.ADF]: 'netezza',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.odata.linkedServiceType]: {
        [contextType.ADF]: 'odata',
        [contextType.Trident]: 'https://aka.ms/ODataCopyConnector'
    },
    [adfModelTypeMap.odbc.linkedServiceType]: {
        [contextType.ADF]: 'odbc',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.office365.linkedServiceType]: {
        [contextType.ADF]: 'office-365',
        [contextType.Trident]: 'https://aka.ms/Microsoft365Connector'
    },
    [adfModelTypeMap.oracle.linkedServiceType]: {
        [contextType.ADF]: 'oracle',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.oracleEloqua.linkedServiceType]: {
        [contextType.ADF]: 'oracle-eloqua',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.oracleResponsys.linkedServiceType]: {
        [contextType.ADF]: 'oracle-responsys',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.oracleServiceCloud.linkedServiceType]: {
        [contextType.ADF]: 'oracle-service-cloud',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.paypal.linkedServiceType]: {
        [contextType.ADF]: 'paypal',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.phoenix.linkedServiceType]: {
        [contextType.ADF]: 'phoenix',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.postgreSql.linkedServiceType]: {
        [contextType.ADF]: 'postgresql',
        [contextType.Trident]: 'https://aka.ms/PostgreSQLCopyConnector'
    },
    [adfModelTypeMap.postgreSqlV2.linkedServiceType]: {
        [contextType.ADF]: 'postgresql',
        [contextType.Trident]: 'https://aka.ms/PostgreSQLCopyConnector'
    },
    [adfModelTypeMap.presto.linkedServiceType]: {
        [contextType.ADF]: 'presto',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.quickBooks.linkedServiceType]: {
        [contextType.ADF]: 'quickbooks',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.rest.linkedServiceType]: {
        [contextType.ADF]: 'rest',
        [contextType.Trident]: 'https://aka.ms/RESTCopyConnector'
    },
    [adfModelTypeMap.salesforce.linkedServiceType]: {
        [contextType.ADF]: 'salesforce',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.salesforceV2.linkedServiceType]: {
        [contextType.ADF]: 'salesforce',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.salesforceServiceCloud.linkedServiceType]: {
        [contextType.ADF]: 'salesforce-service-cloud',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.salesforceServiceCloudV2.linkedServiceType]: {
        [contextType.ADF]: 'salesforce-service-cloud',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.salesforceMarketingCloud.linkedServiceType]: {
        [contextType.ADF]: 'salesforce-marketing-cloud',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sapOpenHub.linkedServiceType]: {
        [contextType.ADF]: 'sap-business-warehouse-open-hub',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sapBw.linkedServiceType]: {
        [contextType.ADF]: 'sap-business-warehouse',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sapc4c.linkedServiceType]: {
        [contextType.ADF]: 'sap-cloud-for-customer',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sapecc.linkedServiceType]: {
        [contextType.ADF]: 'sap-ecc',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sapHana.linkedServiceType]: {
        [contextType.ADF]: 'sap-hana',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sapTable.linkedServiceType]: {
        [contextType.ADF]: 'sap-table',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.serviceNow.linkedServiceType]: {
        [contextType.ADF]: 'servicenow',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.serviceNowV2.linkedServiceType]: {
        [contextType.ADF]: 'servicenow',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sftp.linkedServiceType]: {
        [contextType.ADF]: 'sftp',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sharePointOnlineList.linkedServiceType]: {
        [contextType.ADF]: 'sharepoint-online-list',
        [contextType.Trident]: 'https://aka.ms/SharePointOnlineList'
    },
    [adfModelTypeMap.shopify.linkedServiceType]: {
        [contextType.ADF]: 'shopify',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.snowflake.linkedServiceType]: {
        [contextType.ADF]: 'snowflake',
        [contextType.Trident]: 'https://aka.ms/SnowflakeCopyConnector'
    },
    [adfModelTypeMap.snowflakeV2.linkedServiceType]: {
        [contextType.ADF]: 'snowflake',
        [contextType.Trident]: 'https://aka.ms/SnowflakeCopyConnector'
    },
    [adfModelTypeMap.spark.linkedServiceType]: {
        [contextType.ADF]: 'spark',
        [contextType.Trident]: 'https://aka.ms/SparkCopyConnector'
    },
    [adfModelTypeMap.sqlServer.linkedServiceType]: {
        [contextType.ADF]: 'sql-server',
        [contextType.Trident]: 'https://aka.ms/SQLserverCopyConnector'
    },
    [adfModelTypeMap.square.linkedServiceType]: {
        [contextType.ADF]: 'square',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.sybase.linkedServiceType]: {
        [contextType.ADF]: 'sybase',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.teradata.linkedServiceType]: {
        [contextType.ADF]: 'teradata',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.vertica.linkedServiceType]: {
        [contextType.ADF]: 'vertica',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.webTable.linkedServiceType]: {
        [contextType.ADF]: 'web-table',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.xero.linkedServiceType]: {
        [contextType.ADF]: 'xero',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.zoho.linkedServiceType]: {
        [contextType.ADF]: 'zoho',
        [contextType.Trident]: ''
    },
    // compute
    [adfModelTypeMap.hdInsight.linkedServiceType]: {
        [contextType.ADF]: 'azure-hdinsight-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.hDInsightOnDemand.linkedServiceType]: {
        [contextType.ADF]: 'azure-hdinsight-on-demand-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureBatch.linkedServiceType]: {
        [contextType.ADF]: 'azure-batch-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureMl.linkedServiceType]: {
        [contextType.ADF]: 'machine-learning-studio-classic-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.amlService.linkedServiceType]: {
        [contextType.ADF]: 'azure-machine-learning-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureDataLakeAnalytics.linkedServiceType]: {
        [contextType.ADF]: 'azure-data-lake-analytics-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureDatabricks.linkedServiceType]: {
        [contextType.ADF]: 'azure-databricks-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureFunction.linkedServiceType]: {
        [contextType.ADF]: 'azure-function-linked-service',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.azureSynapseArtifacts.linkedServiceType]: {
        [contextType.ADF]: 'azure-synapse-analytics-artifacts-linked-service',
        [contextType.Trident]: 'https://aka.ms/AzureSynapseAnalyticsConnector'
    },
    [adfModelTypeMap.lakehouse.linkedServiceType]: {
        [contextType.ADF]: 'microsoft-fabric-lakehouse',
        [contextType.Trident]: 'https://aka.ms/LakehouseCopyConnector'
    },
    [adfModelTypeMap.DataWarehouse.linkedServiceType]: {
        [contextType.ADF]: '',
        [contextType.Trident]: 'https://aka.ms/DataWarehouse'
    },
    [adfModelTypeMap.Warehouse.linkedServiceType]: {
        [contextType.ADF]: 'microsoft-fabric-warehouse',
        [contextType.Trident]: ''
    },
    [adfModelTypeMap.kustoDatabase.linkedServiceType]: {
        [contextType.ADF]: '',
        [contextType.Trident]: 'https://aka.ms/KQLDatabase'
    },
};

// // This is specific links for connectors which don't follow the common link rule.
// // For now we don't need this, but we will remove it once all the docs are ready
// //and we still don't need it
// export const specialConnectorDocLinkDictionary: LinksMapType = {
//     [adfModelTypeMap.azureSqlDW.linkedServiceType]: {
//         [contextType.Trident]: 'https://www.baidu.com'
//     }
// }
// ----------------------------------------------------------------------------------

export const linksMap: ILinksMapType = {
    // monitor doc link in activity-run.component
    'https://go.microsoft.com/fwlink/?linkid=2151347': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2230736'
    },
    // activity settings:
    // enable staging
    'https://go.microsoft.com/fwlink/?linkid=2159335': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2231232'
    },
    // fault tolerance
    'https://learn.microsoft.com/azure/data-factory/copy-activity-fault-tolerance#copying-tabular-data': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2231233'
    },
    // Maximum data integration unit
    'https://docs.microsoft.com/azure/data-factory/copy-activity-performance#data-integration-units': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2231139'
    },
    // Variable type
    'https://aka.ms/adfpipelinereturnvalue': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2231140'
    },
    //Format Properties
    'https://go.microsoft.com/fwlink/?linkid=2185155': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2231039'
    },
    // Import-export-settings:
    'https://aka.ms/snowflake-source-copy-options': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2258680'
    },
    'https://aka.ms/snowflake-sink-copy-options': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2258860'
    },
    'https://aka.ms/snowflake-source-format-options': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2258680'
    },
    'https://aka.ms/snowflake-sink-format-options': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2258860'
    },
    // Storage Integration:
    'https://learn.microsoft.com/azure/data-factory/connector-snowflake?tabs=data-factory#copy-activity-properties': {
        [contextType.Trident]: 'https://go.microsoft.com/fwlink/?linkid=2258680'
    }
};


export const enableStagingDocLink: string = 'https://go.microsoft.com/fwlink/?linkid=2159335';
export const irSharingReferenceLink = 'https://go.microsoft.com/fwlink/?linkid=2166984';
export const tableLockInfoLink = 'https://go.microsoft.com/fwlink/?linkid=2167229';
export const sftpDisableChunkingInfoLink = 'https://go.microsoft.com/fwlink/?linkid=2170025';
export const ftpDisableChunkingInfoLink = 'https://go.microsoft.com/fwlink/?linkid=2172613';
export const stalePublishBranchDocLink = 'https://go.microsoft.com/fwlink/?linkid=2193931';
export const linkedTemplateDocLink = 'https://docs.microsoft.com/azure/data-factory/continuous-integration-deployment#linked-resource-manager-templates';
export const customArmParameterDocLink = 'https://docs.microsoft.com/azure/data-factory/continuous-integration-deployment#use-custom-parameters-with-the-resource-manager-template';
export const storageUrlForm = `https://<accountname>.{0}.${AuthConstants.RESOURCE_DOMAIN_MAP.AzureBlobStorage}`;
export const containerUriForm = `https://<accountname>.{0}.${AuthConstants.RESOURCE_DOMAIN_MAP.AzureBlobStorage}/<containername>`;
export const m365admiCenterLink = 'https://admin.microsoft.com/';
export const deprecatedConnectorDocLink = 'https://go.microsoft.com/fwlink/?linkid=2286321';
export const sapCdcDeprecationDocLink = 'https://aka.ms/adfsapcdcupdate';
export const sharePointSpnRetirementDocLink = 'https://learn.microsoft.com/azure/data-factory/connector-sharepoint-online-list?tabs=data-factory#linked-service-properties';
export const getArtifactIdDocLink = 'https://learn.microsoft.com/fabric/data-factory/copy-data-activity?branch=main&branchFallbackFrom=pr-en-us-1825#configure-parameters-in-a-copy-activity';
export const getConnectionIdDocLink = 'https://go.microsoft.com/fwlink/?linkid=2304105';
export const depWarningDocLink = 'https://go.microsoft.com/fwlink/?linkid=2345238';
export const auditColLink = 'https://go.microsoft.com/fwlink/?linkid=2352236'; // TODO: update link - doc not available until product release